/* eslint-disable */
import { useTranslation as useUiTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import axios from "axios";

const DigitalProductForm = ({ product, onProductUpdate }) => {
  const { t: uiT } = useUiTranslation();
  const [productType, setProductType] = useState("");
  const [hasOffers, setHasOffers] = useState(false);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [digitalInfoArray, setDigitalInfoArray] = useState([
    {
      id: 0,
      name: "",
      digitalType: "",
      price: product.price ?? 0,
      content: [],
      isDefault: true,
    },
  ]);
  const [activeOfferIndex, setActiveOfferIndex] = useState(0);
  const getTypeLabel = (type) => {
    const labels = {
      pdf: "PDF",
      keys: uiT("ui.digital_codes"),
      file: uiT("ui.digital_files"),
      link: uiT("ui.digital_links"),
      emailPassword: uiT("ui.digital_accounts"),
      calendar: uiT("ui.digital_dates"),
    };
    return labels[type] || type;
  };
  useEffect(() => {
    if (product?.digitalInfo && Array.isArray(product.digitalInfo)) {
      setDigitalInfoArray(product.digitalInfo);
      setHasOffers(product.digitalInfo.length > 1);
      if (product.digitalInfo[0]?.digitalType) {
        setProductType(product.digitalInfo[0].digitalType);
      }
    } else if (product?.digitalInfo && !Array.isArray(product.digitalInfo)) {
      // Migration depuis l'ancien format
      const migratedInfo = {
        id: 0,
        name: "",
        digitalType: product.digitalInfo.digitalType || "",
        price: product.digitalInfo.price || 0,
        content: product.digitalInfo.content || [],
        isDefault: true,
      };
      setDigitalInfoArray([migratedInfo]);
      setProductType(migratedInfo.digitalType);
    }
  }, [product]);

  const handleProductTypeChange = (type, event) => {
    event.preventDefault();
    event.stopPropagation();
    setProductType(type);

    // Mettre à jour le type pour toutes les offres
    const updatedArray = digitalInfoArray.map((offer) => ({
      ...offer,
      digitalType: type,
      content: [], // Reset content when changing type
    }));

    setDigitalInfoArray(updatedArray);
    updateProduct(updatedArray);
  };

  const handleOffersToggle = (useOffers) => {
    setHasOffers(useOffers);

    if (!useOffers) {
      // Garder seulement l'offre par défaut
      const defaultOffer =
        digitalInfoArray.find((offer) => offer.isDefault) ||
        digitalInfoArray[0];
      setDigitalInfoArray([{ ...defaultOffer, isDefault: true }]);
      setActiveOfferIndex(0);
    } else {
      // Ajouter une offre exemple si on n'a que l'offre par défaut
      if (digitalInfoArray.length === 1) {
        const newOffer = {
          id: Date.now(),
          name: "",
          digitalType: productType,
          price: 0,
          content: [],
          isDefault: false,
        };
        setDigitalInfoArray([...digitalInfoArray, newOffer]);
      }
    }
  };

  const addNewOffer = () => {
    const newOffer = {
      id: Date.now(),
      name: "",
      digitalType: productType,
      price: 0,
      content: [],
      isDefault: false,
    };
    const updatedArray = [...digitalInfoArray, newOffer];
    setDigitalInfoArray(updatedArray);
    setActiveOfferIndex(updatedArray.length - 1);
    updateProduct(updatedArray);
  };

  const removeOffer = (index) => {
    if (digitalInfoArray[index]?.isDefault) return;

    const updatedArray = digitalInfoArray.filter((_, i) => i !== index);
    setDigitalInfoArray(updatedArray);

    if (activeOfferIndex >= updatedArray.length) {
      setActiveOfferIndex(updatedArray.length - 1);
    }
    updateProduct(updatedArray);
  };

  const updateOfferProperty = (index, property, value) => {
    const updatedArray = digitalInfoArray.map((offer, i) =>
      i === index ? { ...offer, [property]: value } : offer
    );
    setDigitalInfoArray(updatedArray);
    updateProduct(updatedArray);
  };

  const parseSingleLine = (line, type) => {
    const trimmed = line.trimEnd();
    let usageLimit = 1;
    let cleanLine = trimmed;
    if (trimmed.endsWith("*")) {
      cleanLine = trimmed.slice(0, -1).trimEnd();
      usageLimit = Infinity;
    } else {
      const parts = trimmed.split(" ");
      const lastPart = parts[parts.length - 1];
      const parsedNumber = parseInt(lastPart);

      if (!isNaN(parsedNumber)) {
        usageLimit = parsedNumber;
        parts.pop();
        cleanLine = parts.join(" ").trim();
      }
    }

    const getObject = (main) => ({
      usageLimit,
      currentUsage: 0,
      ...main,
    });

    switch (type) {
      case "keys":
        return getObject({ key: cleanLine });
      case "emailPassword":
        const [email, password] = cleanLine.split(":").map((s) => s.trim());
        // return getObject({ email: email || "", password: password || "" });
        return getObject({ key: `${email}:${password}` });

      case "link":
        return getObject({ key: cleanLine });
      case "pdf":
      case "file":
        return getObject({ key: cleanLine });
      case "calendar":
        return getObject({ key: cleanLine });
      default:
        return getObject({ key: cleanLine });
    }
  };

  const updateProduct = (updatedArray) => {
    if (onProductUpdate) {
      const updatedProduct = {
        ...product,
        digitalInfo: updatedArray,
      };
      onProductUpdate(updatedProduct);
    }
  };

  const handleContentChange = (text, offerIndex) => {
    setTextAreaValue(text);

    const inputLines = text.split("\n").filter((line) => line.trim() !== "");

    const parsedLines = inputLines.map((line) => {
      const trimmed = line.trim();

      if (trimmed.includes("|")) {
        const [main, usage] = trimmed.split("|").map((s) => s.trim());

        let usageLimit =
          usage === "*" || usage.toLowerCase() === "infinity"
            ? Infinity
            : parseInt(usage);

        if (isNaN(usageLimit)) usageLimit = 1;

        switch (productType) {
          case "keys":
            return { key: main, usageLimit, currentUsage: 0 };
          case "emailPassword":
            const [email, password] = main.split(":").map((s) => s.trim());
            return {
              key: `${email}:${password}`,
              usageLimit,
              currentUsage: 0,
              type: "emailPassword",
            };
          case "link":
            return { key: main, usageLimit, currentUsage: 0 };
          case "pdf":
            return { key: main, usageLimit, currentUsage: 0 };
          case "file":
            return { key: main, usageLimit, currentUsage: 0 };
          case "calendar":
            return { key: main, usageLimit, currentUsage: 0 };
          default:
            return { key: main, usageLimit, currentUsage: 0 };
        }
      }
      return parseSingleLine(trimmed, productType);
    });

    updateOfferProperty(offerIndex, "content", parsedLines);
  };
  const getContentText = (content, type) => {
    if (!content || content.length === 0) return "";

    return content
      .map((item) => {
        const baseText =
          type === "emailPassword"
            ? `${item.email}:${item.password}`
            : type === "keys"
            ? item.key
            : type === "link"
            ? item.key
            : item.key || item.key || item.key || "";

        // إذا usageLimit غير موجود، نخليه فقط "|"
        return `${baseText}|${item.usageLimit ?? ""}`;
      })
      .join("\n");
  };

  const getPlaceholderText = (type) => {
    switch (type) {
      case "keys":
        return uiT("ui.keysExample");
      case "emailPassword":
        return uiT("ui.credentialsExample");
      case "link":
        return uiT("ui.linksExample");
      case "pdf":
        return uiT("ui.pdfsExample");
      case "file":
        return uiT("ui.filesExample");
      case "calendar":
        return uiT("ui.datesExample");
      default:
        return uiT("ui.enterContent");
    }
  };

  const getLabelText = (type) => {
    switch (type) {
      case "keys":
        return uiT("ui.enterKeys");
      case "emailPassword":
        return uiT("ui.enterCredentials");
      case "link":
        return uiT("ui.enterLinks");
      case "pdf":
        return uiT("ui.uploadPdfs");
      case "file":
        return uiT("ui.uploadFiles");
      case "calendar":
        return uiT("ui.enterDates");
      default:
        return uiT("ui.enterContentLabel");
    }
  };

  const uploadImage = async (file) => {
    const dataImage = new FormData();
    const hasArabic = /[\u0600-\u06FF]/.test(file.name);
    const hasSpecialChars = /[^a-zA-Z0-9._-]/.test(file.name);

    let filename;
    if (hasArabic || hasSpecialChars) {
      const extension = file.name.split(".").pop();
      filename = `${Date.now()}-${Math.random()
        .toString(36)
        .substring(2, 15)}.${extension}`;
    } else {
      filename = `${Date.now()}-${file.name}`;
    }

    dataImage.append("upload", file, filename);

    const response = await axios.post(
      "https://octopus-app-i4ylg.ondigitalocean.app/upload",
      dataImage,
      { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    return response.data.url;
  };

  const handleFileUpload = async (event, offerIndex, productType) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setIsUploading(true);
      const fileUrl = await uploadImage(file);

      const fileData = {
        key: fileUrl,
        fileName: file.name,
        usageLimit: Infinity,
        currentUsage: 0,
        type: productType === "pdf" ? "pdf" : "file",
      };
      const currentContent = currentOffer.content || [];
      const updatedContent = [...currentContent, fileData];
      updateOfferProperty(offerIndex, "content", updatedContent);
      const displayText = textAreaValue
        ? `${textAreaValue}\n${file.name}`
        : file.name;
      setTextAreaValue(displayText);
    } catch (error) {
      console.error("Erreur lors du téléchargement:", error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemoveFile = (index) => {
    const updatedContent = currentOffer.content.filter((_, i) => i !== index);
    updateOfferProperty(activeOfferIndex, "content", updatedContent);

    // if (updatedContent.length === 0) {
    //   setTextAreaValue("");
    // } else {
    //   const fileNames = updatedContent
    //     .filter((item) => item.fileName)
    //     .map((item) => item.fileName)
    //     .join("\n");
    //   setTextAreaValue(fileNames);
    // }
  };

  const currentOffer = digitalInfoArray[activeOfferIndex];

  useEffect(() => {
    if (currentOffer?.content && productType) {
      const contentText = getContentText(currentOffer.content, productType);
      setTextAreaValue(contentText);
    } else {
      setTextAreaValue("");
    }
  }, [currentOffer, productType]);

  return (
    <div className="border min-h-full border-gray-300 rounded-lg shadow-sm w-full bg-white flex flex-col gap-2 mb-3">
      <div className="p-4 text-lg font-semibold">{uiT("ui.digitalProductTypePrompt")}</div>

      {/* Type selection */}
      <div className="p-6 bg-gray-50">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          {uiT("ui.digitalProductType")}
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {["pdf", "keys", "file", "link", "emailPassword", "calendar"].map(
            (type) => (
              <button
                key={type}
                type="button"
                className={`p-4 rounded-lg text-sm font-medium transition-all duration-200 transform hover:scale-105 ${
                  productType === type
                    ? "bg-blue-500 text-white shadow-lg ring-2 ring-blue-300"
                    : "bg-white text-gray-700 border border-gray-200 hover:bg-blue-50 hover:border-blue-300"
                }`}
                onClick={(e) => handleProductTypeChange(type, e)}
              >
                <div className="text-center">
                  <div className="text-lg mb-1">
                    {type === "pdf" && "📄"}
                    {type === "keys" && "🔑"}
                    {type === "file" && "📁"}
                    {type === "link" && "🔗"}
                    {type === "emailPassword" && "👤"}
                    {type === "calendar" && "📅"}
                  </div>
                  {getTypeLabel(type)}
                </div>
              </button>
            )
          )}
        </div>
      </div>

      {/* Offers toggle */}
      {productType && (
        <div className="p-4 border-t border-gray-200">
          <div className="mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              {uiT("ui.offerMode")}
            </h3>
            <div className="flex items-center gap-6 p-4 bg-gray-50 rounded-lg">
              <div className="flex items-center">
                <input
                  type="radio"
                  id="noOffers"
                  name="offersType"
                  checked={!hasOffers}
                  onChange={() => handleOffersToggle(false)}
                  className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />
                <label
                  htmlFor="noOffers"
                  className="mr-2 text-sm font-medium text-gray-700"
                >
                  {uiT("ui.singleOffer")}
                </label>
              </div>
              <div className="flex items-center">
                <input
                  type="radio"
                  id="withOffers"
                  name="offersType"
                  checked={hasOffers}
                  onChange={() => handleOffersToggle(true)}
                  className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />
                <label
                  htmlFor="withOffers"
                  className="mr-2 text-sm font-medium text-gray-700"
                >
                  {uiT("ui.multipleOffers")}
                </label>
              </div>
            </div>
          </div>

          {/* Offers management */}
          {hasOffers && (
            <div className="mb-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-700">
                  {uiT("ui.manageOffers")}
                </span>
                <button
                  type="button"
                  onClick={addNewOffer}
                  className="px-3 py-1 bg-green-500 text-white text-sm rounded hover:bg-green-600"
                >
                  {uiT("ui.addOffer")}
                </button>
              </div>

              <div className="flex gap-2 flex-wrap mb-4">
                {digitalInfoArray.map((offer, index) => (
                  <div key={offer.id} className="flex items-center gap-1">
                    <button
                      type="button"
                      onClick={() => setActiveOfferIndex(index)}
                      className={`px-3 py-1 text-sm rounded ${
                        activeOfferIndex === index
                          ? "bg-blue-500 text-white"
                          : "bg-gray-200 hover:bg-gray-300"
                      }`}
                    >
                      {offer.name || uiT("ui.offerNumber", { value0: (index + 1) })}
                    </button>
                    {!offer.isDefault && (
                      <button
                        type="button"
                        onClick={() => removeOffer(index)}
                        className="px-2 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-600"
                      >
                        ×
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Current offer configuration */}
          {currentOffer && (
            <div className="space-y-4 border-t border-gray-200 pt-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {digitalInfoArray.length > 1 || !currentOffer.isDefault ? (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {uiT("ui.offerName")}
                    </label>
                    <input
                      type="text"
                      value={currentOffer.name}
                      onChange={(e) =>
                        updateOfferProperty(
                          activeOfferIndex,
                          "name",
                          e.target.value
                        )
                      }
                      className="block w-full text-sm text-gray-900 border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>
                ) : (
                  <></>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {uiT("ui.priceDzdRequired")}
                  </label>
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    value={currentOffer.price || 0}
                    onChange={(e) =>
                      updateOfferProperty(
                        activeOfferIndex,
                        "price",
                        parseFloat(e.target.value) || 0
                      )
                    }
                    className="block w-full text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
                    placeholder="0.00"
                  />
                </div>
              </div>

              <div>
                <label
                  htmlFor="productContent"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  {getLabelText(productType)}
                </label>

                {productType === "pdf" || productType === "file" ? (
                  <div className="space-y-4">
                    <div className="relative">
                      <input
                        type="file"
                        id="fileUpload"
                        accept={productType === "pdf" ? ".pdf" : "*"}
                        onChange={(e) =>
                          handleFileUpload(e, activeOfferIndex, productType)
                        }
                        className="hidden"
                        disabled={isUploading}
                      />
                      <label
                        htmlFor="fileUpload"
                        className={`
            flex flex-col items-center justify-center w-full h-32
            border-2 border-dashed rounded-lg cursor-pointer
            transition-all duration-200 ease-in-out
            ${
              isUploading
                ? "border-blue-300 bg-blue-50 cursor-not-allowed"
                : "border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-gray-400"
            }
          `}
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          {isUploading ? (
                            <div className="flex items-center space-x-2">
                              <svg
                                className="animate-spin h-5 w-5 text-blue-500"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                              <span className="text-sm text-blue-600">
                                {uiT("loading")}
                              </span>
                            </div>
                          ) : (
                            <>
                              <svg
                                className="w-8 h-8 mb-4 text-gray-500"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 16"
                              >
                                <path
                                  stroke="currentColor"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                />
                              </svg>
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold">
                                  {uiT("ui.clickUpload")}
                                </span>{" "}
                                {uiT("ui.fileDropHint")}
                              </p>
                              <p className="text-xs text-gray-500">
                                {productType === "pdf"
                                  ? uiT("ui.pdfFilesOnly")
                                  : uiT("ui.allFileTypes")}
                              </p>
                            </>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                ) : (
                  <textarea
                    id="productContent"
                    rows="6"
                    value={textAreaValue}
                    onChange={(e) => setTextAreaValue(e.target.value)}
                    onBlur={() =>
                      handleContentChange(textAreaValue, activeOfferIndex)
                    }
                    placeholder={getPlaceholderText(productType)}
                    className="block w-full text-sm text-gray-900 border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                )}

                <p className="text-xs text-gray-500 mt-1">
                  {productType === "pdf" || productType === "file"
                    ? uiT("ui.unlimitedFiles")
                    : uiT("ui.usageFormat")}
                </p>
              </div>
              {/* Content preview */}
              {currentOffer.content && currentOffer.content.length > 0 && (
                <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-lg p-4 border border-green-200">
                  <h5 className="text-sm font-semibold text-gray-800 mb-3 flex items-center gap-2">
                    <span>✅</span>
                    {uiT("ui.previewParsedContent")}
                  </h5>
                  <div className="space-y-2 max-h-48 overflow-y-auto">
                    {currentOffer.content.map((item, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between bg-white rounded-lg p-3 border border-gray-200 hover:border-gray-300 transition-colors"
                      >
                        <div className="flex-1 flex items-center gap-3">
                          {/* Icône selon le type */}
                          {productType === "pdf" ? (
                            <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
                              <svg
                                className="w-5 h-5 text-red-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          ) : productType === "file" ? (
                            <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                              <svg
                                className="w-5 h-5 text-blue-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          ) : (
                            <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center">
                              <svg
                                className="w-5 h-5 text-gray-600"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h12v8H4V6z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          )}

                          <div className="flex-1 min-w-0">
                            <span className="font-mono text-sm text-gray-800 block truncate">
                              {productType === "emailPassword"
                                ? `${item.email} : ${item.password}`
                                : productType === "pdf" && item.fileName
                                ? item.fileName
                                : productType === "file" && item.fileName
                                ? item.fileName
                                : productType === "keys"
                                ? item.key
                                : productType === "link"
                                ? item.key
                                : item.key}
                            </span>
                            {/* {(productType === "pdf" ||
                              productType === "file") &&
                              item.fileName && (
                                <span className="text-xs text-gray-500 block truncate">
                                  رابط الملف: {item.key}
                                </span>
                              )} */}
                          </div>
                        </div>

                        <div className="flex items-center gap-2">
                          <div className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800 font-medium">
                            {item.usageLimit === Infinity
                              ? "∞"
                              : `${item.usageLimit}x`}
                          </div>

                          {/* Bouton supprimer */}
                          <button
                            onClick={() => handleRemoveFile(index)}
                            className="flex-shrink-0 w-7 h-7 bg-red-100 hover:bg-red-200 text-red-600 rounded-full flex items-center justify-center transition-colors duration-200 group"
                            title={uiT("ui.deleteFile")}
                          >
                            <svg
                              className="w-4 h-4 group-hover:scale-110 transition-transform"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 pt-3 border-t border-green-200 flex justify-between items-center text-sm">
                    <span className="font-medium text-green-700">
                      {uiT("ui.itemCountLabel")} {currentOffer.content.length}
                    </span>
                    <span className="font-bold text-blue-700">
                      {uiT("ui.priceLabel")} {currentOffer.price || 0} {uiT("ui.dzd")}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DigitalProductForm;
